import React, { useState } from 'react';
import { Icon } from '@/shared/icons';
import {
  useAudienceImportSocket,
  type AudienceImportEventPayload,
} from '../hooks';

export interface ImportProgressBadgeProps {
  audienceId: string;
  initialVisible?: boolean;
}

export const ImportProgressBadge: React.FC<ImportProgressBadgeProps> = ({
  audienceId,
  initialVisible = false,
}) => {
  const [visible, setVisible] = useState(initialVisible);
  const [progress, setProgress] = useState<AudienceImportEventPayload | null>(null);

  useAudienceImportSocket(audienceId, {
    onStarted: (data) => {
      setVisible(true);
      setProgress(data);
    },
    onProgress: (data) => {
      setVisible(true);
      setProgress(data);
    },
    onCompleted: () => {
      setTimeout(() => {
        setVisible(false);
        setProgress(null);
      }, 2000);
    },
    onFailed: () => {
      setVisible(false);
      setProgress(null);
    },
  });

  if (!visible) return null;

  const imported = progress?.imported ?? 0;
  const total = progress?.totalLines ?? 0;
  const percent = total > 0 ? Math.min(100, Math.round((imported / total) * 100)) : 0;

  return (
    <div
      className="rounded-lg border p-4 mb-4 flex items-center gap-4"
      style={{
        backgroundColor: 'var(--theme-info-background)',
        borderColor: 'var(--theme-info-color)',
      }}
    >
      <div
        className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
        style={{ backgroundColor: 'var(--theme-info-color)', color: '#ffffff' }}
      >
        <Icon name="upload" className="w-5 h-5 animate-pulse" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium" style={{ color: 'var(--theme-info-color)' }}>
          Importação em andamento...
        </p>
        <p className="text-xs mt-1" style={{ color: 'var(--theme-info-color)' }}>
          {imported} de {total} linhas processadas ({percent}%)
        </p>
        <div
          className="mt-2 w-full h-1.5 rounded-full overflow-hidden"
          style={{ backgroundColor: 'rgba(0,0,0,0.1)' }}
        >
          <div
            className="h-full transition-all duration-300"
            style={{
              width: `${percent}%`,
              backgroundColor: 'var(--theme-info-color)',
            }}
          />
        </div>
      </div>
    </div>
  );
};
